import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CurrencyService } from 'services';
import { Currency } from 'models';

@Injectable({
	providedIn: 'root',
})
export class CurrencyResolver implements Resolve<Currency[]> {
	constructor(private currencyService: CurrencyService) {}

	resolve(route: ActivatedRouteSnapshot): Observable<Currency[]> {
		return this.currencyService.getCurrencies();
	}
}
